import { render, staticRenderFns } from "./ExEmployeeIssueBadge.vue?vue&type=template&id=2fa81c47&scoped=true"
import script from "./ExEmployeeIssueBadge.vue?vue&type=script&lang=js"
export * from "./ExEmployeeIssueBadge.vue?vue&type=script&lang=js"
import style0 from "./ExEmployeeIssueBadge.vue?vue&type=style&index=0&id=2fa81c47&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa81c47",
  null
  
)

export default component.exports